module.exports = __webpack_public_path__ + "img/iconfonti.2f2231d2.png";